/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  MobileDeviceSummary,
  SendTestNotificationRequest,
} from "../models/index";
import {
  MobileDeviceSummaryFromJSON,
  MobileDeviceSummaryToJSON,
  SendTestNotificationRequestFromJSON,
  SendTestNotificationRequestToJSON,
} from "../models/index";

export interface ListMobileDevicesForCompanyRequest {
  companyId: string;
}

export interface SendTestNotificationOperationRequest {
  sendTestNotificationRequest: SendTestNotificationRequest;
}

/**
 *
 */
export class MobileDevicesApi extends runtime.BaseAPI {
  /**
   */
  async listMobileDevicesForCompanyRaw(
    requestParameters: ListMobileDevicesForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<MobileDeviceSummary>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling listMobileDevicesForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/mobile-devices/list-for-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(MobileDeviceSummaryFromJSON),
    );
  }

  /**
   */
  async listMobileDevicesForCompany(
    requestParameters: ListMobileDevicesForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<MobileDeviceSummary>> {
    const response = await this.listMobileDevicesForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async sendTestNotificationRaw(
    requestParameters: SendTestNotificationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["sendTestNotificationRequest"] == null) {
      throw new runtime.RequiredError(
        "sendTestNotificationRequest",
        'Required parameter "sendTestNotificationRequest" was null or undefined when calling sendTestNotification().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/mobile-devices/send-test-notification`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SendTestNotificationRequestToJSON(
          requestParameters["sendTestNotificationRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async sendTestNotification(
    requestParameters: SendTestNotificationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.sendTestNotificationRaw(requestParameters, initOverrides);
  }
}
